import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsLeadTimeMessageStyles {
    leadTimeWrapper?: InjectableCss;
    leadTimeText?: TypographyProps;
}

export const leadTimeMessageStyles: ProductDetailsLeadTimeMessageStyles = {
    leadTimeWrapper: {
        css: css`
            margin-top: 2px;
            margin-bottom: 8px;
        `,
    },
    leadTimeText: {
        css: css`
            font-size: 13px;
            padding-bottom: 8px;
            line-height: 16px;
            color: #7d7e81;
        `,
    },
};

const styles = leadTimeMessageStyles;

const ProductDetailsLeadTimeMessage: React.FC<Props> = ({ product }) => {
    if (!product.properties.showStock) {
        return null;
    }
    if (product?.properties?.showStock?.toLowerCase() === "true") {
        return (
            <StyledWrapper {...styles.leadTimeWrapper}>
                <Typography {...styles.leadTimeText}>Usually In Stock</Typography>
            </StyledWrapper>
        );
    }
    return (
        <StyledWrapper {...styles.leadTimeWrapper}>
            <Typography {...styles.leadTimeText}>Lead Time Required</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsLeadTimeMessage),
    definition: {
        displayName: "Lead Time Message",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
